<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Michela Arturina Betta was born in Italy. She went to school in Riva del Garda and to university in Milan and Frankfurt. Here she completed her studies and received her PhD in philosophy. Afterward, she travelled to Melbourne where she worked as an academic for several years. In 2018, she moved to Stockholm where she is currently living. She has written several fiction books in Italian and English.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?144e2a22